const elements = document.querySelectorAll('.icon-volumen');
let width = 0;
if(elements){
    let multi = elements.length<=6?1.3:0.9;
    for (let item of elements) {
        let size = item.id.split('-');
        if(size[1] == 0) 
            width = 3;
        else
            width = width + 0.5 + (multi * (parseInt(size[1])-1));
            
        item.style.width = width+"rem";
    }
}


